import { __read } from "tslib";
import { BlankScreenMonitor } from '../../monitors/blank-screen';
import { DEFAULT_THRESHOLD } from '../../monitors/blank-screen/util';
import { applyMonitor } from '../../utils';
import { getPluginConfig } from './utils';
export var BLANK_SCREEN_MONITOR_PLUGIN_NAME = 'blankScreen';
function BlankScreenMonitorBasePlugin(client, defaultConfig) {
    client.on('init', function () {
        var config = getPluginConfig(client, BLANK_SCREEN_MONITOR_PLUGIN_NAME, defaultConfig);
        if (!config) {
            return;
        }
        var _a = __read(applyMonitor(BlankScreenMonitor, config, client.report.bind(client)), 3), tearDown = _a[0], applyOtherReport = _a[1], detectBlankScreen = _a[2];
        var listenOtherReport = function (ev) {
            applyOtherReport(ev);
            return ev;
        };
        client.on('report', listenOtherReport);
        client.on('beforeDestroy', function () {
            tearDown();
            client.off('report', listenOtherReport);
        });
        client.provide('detectBlankScreen', detectBlankScreen);
    });
}
var defaultByteConfig = {
    autoDetect: true,
    threshold: DEFAULT_THRESHOLD,
    screenshot: true,
    ssUrl: 'https://unpkg.byted-static.com/html2canvas/1.0.0-rc.7/dist/html2canvas.min.js',
};
export function BlankScreenMonitorPlugin(client) {
    BlankScreenMonitorBasePlugin(client, defaultByteConfig);
}
var defaultVolConfig = {
    autoDetect: true,
    threshold: DEFAULT_THRESHOLD,
    screenshot: true,
    ssUrl: 'https://apm.volccdn.com/mars-web/apmplus/web/html2canvas.min.js',
};
export function BlankScreenMonitorVolPlugin(client) {
    BlankScreenMonitorBasePlugin(client, defaultVolConfig);
}
//# sourceMappingURL=blank-screen.js.map